export const dataHooks = {
    title: 'list-item-action-title',
    subtitle: 'list-item-action-subtitle',
    prefixIcon: 'list-item-action-prefix-icon',
    suffix: 'list-item-action-suffix',
    suffixIcon: 'list-item-action-suffix-icon',
};
//# sourceMappingURL=constants.js.map